var caseReview;

caseReview = function() {
  var $, resizeProportion, videojs;
  $ = require('jquery');
  resizeProportion = require('../../../../_scripts/functions/resize-proportion');
  resizeProportion({
    width: 16,
    height: 9,
    element: '.case_review__video'
  });
  if ($(".case_review__video").length !== 0) {
    videojs = require('video.js');
    return videojs("art_video", {
      controlBar: {
        volumePanel: {
          inline: false
        }
      }
    });
  }
};

module.exports = caseReview;
